/**
 * E-book single: email the PDF via AJAX, then continue the normal Zoho submit.
 * Sends the form nonce (data-nonce) and the reCAPTCHA token so the server can verify the request.
 */
document.addEventListener('DOMContentLoaded', function () {
    var form = document.querySelector('.ebook-download-form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
        e.preventDefault();

        var btn = document.getElementById('ebook-download-btn');
        var msgBox = document.getElementById('ebook-form-msg');
        var originalBtn = btn.innerHTML;

        // reCAPTCHA must be ticked before anything is sent
        var token = '';
        if (form.querySelector('.g-recaptcha') && window.grecaptcha) {
            token = window.grecaptcha.getResponse();
            if (!token) {
                msgBox.textContent = 'Please confirm you are not a robot.';
                msgBox.style.display = 'block';
                return;
            }
        }

        btn.innerHTML = 'Sending...';
        btn.disabled = true;
        msgBox.style.display = 'none';

        var formData = new FormData();
        formData.append('action', 'send_ebook_pdf');
        formData.append('_wpnonce', form.getAttribute('data-nonce') || '');
        formData.append('g-recaptcha-response', token);
        formData.append('email', form.querySelector('input[name="Email"]').value);
        formData.append('name', form.querySelector('input[name="SingleLine1"]').value);
        formData.append('post_id', form.getAttribute('data-post-id'));

        fetch(window.infinity_ajax_object.ajaxurl, { method: 'POST', body: formData })
            .then(function (response) { return response.json(); })
            .then(function (result) {
                // Too many requests: tell the visitor instead of silently continuing
                if (result && result.success === false && result.data && result.data.code === 'rate_limited') {
                    msgBox.textContent = result.data.message;
                    msgBox.style.display = 'block';
                    btn.innerHTML = originalBtn;
                    btn.disabled = false;
                    return;
                }
                // Resume the normal Zoho redirect
                HTMLFormElement.prototype.submit.call(form);
            })
            .catch(function (error) {
                console.error('Error sending email:', error);
                // Even if it fails, fallback to Zoho redirect
                HTMLFormElement.prototype.submit.call(form);
            });
    });
});
